var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2105,
    cy: 23.2852,
    rx: 24.2105,
    ry: 23,
    fill: "#114559"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3796 30.5794V27.7069C25.3796 27.3171 25.6887 27.0014 26.0698 27.0014C27.4295 27.0014 28.1692 25.5759 28.2719 22.762H26.0698C25.6888 22.762 25.3796 22.4459 25.3796 22.0565V15.991C25.3796 15.6014 25.6887 15.2857 26.0698 15.2857H31.941C32.322 15.2857 32.6312 15.6018 32.6312 15.991V22.0566C32.6312 23.4054 32.498 24.6431 32.2365 25.7363C31.9678 26.8569 31.5554 27.8366 31.0111 28.6485C30.4512 29.4828 29.7503 30.1375 28.929 30.5934C28.1014 31.0523 27.1395 31.2852 26.0695 31.2852C25.6888 31.2849 25.3796 30.9689 25.3796 30.5794ZM16.479 27.0012C16.098 27.0012 15.7891 27.3171 15.7891 27.7063V30.5795C15.7891 30.9689 16.098 31.2846 16.479 31.2846C17.5485 31.2846 18.5109 31.0517 19.3379 30.5929C20.1597 30.137 20.8605 29.4828 21.4204 28.6479C21.9651 27.836 22.3774 26.8563 22.646 25.7351C22.9077 24.642 23.0406 23.4042 23.0406 22.056V15.9905C23.0406 15.6008 22.7313 15.2852 22.3505 15.2852H16.479C16.098 15.2852 15.7891 15.6011 15.7891 15.9905V22.056C15.7891 22.4456 16.098 22.7614 16.479 22.7614H18.6503C18.5489 25.5756 17.8198 27.0012 16.479 27.0012Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.e70cba64c600a48dc32f3840c68b49a9.svg";
export { ForwardRef as ReactComponent };